import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("retrofit_admin_token");
  if (token) config.headers["X-Admin-Token"] = token;
  return config;
});

export const setAdminToken = (token) => {
  if (token) localStorage.setItem("retrofit_admin_token", token);
  else localStorage.removeItem("retrofit_admin_token");
};
export const getAdminToken = () => localStorage.getItem("retrofit_admin_token");

export const LOGO_URL = "/assets/logo.png";
export const VENMO_QR_URL = "/assets/venmo-qr.jpeg";
export const ZELLE_QR_URL = "/assets/zelle-qr.jpeg";
